import * as ROUTES from 'constants/routes'

export function getIndeedFlexShiftAnchorId(ifShiftId: number): string {
  return `if-shift-${ifShiftId}`
}

export function buildIndeedFlexJobShiftsUrl({
  ifJobId,
  ifShiftId,
}: {
  ifJobId?: number | null
  ifShiftId?: number | null
}): string {
  const params = new URLSearchParams()
  if (ifJobId !== undefined && ifJobId !== null) {
    params.set('if-job-id', ifJobId.toString())
  }
  const search = params.toString() ? `?${params.toString()}` : ''
  const hash = ifShiftId ? `#${getIndeedFlexShiftAnchorId(ifShiftId)}` : ''
  return `${ROUTES.INDEED_FLEX_JOB_SHIFTS}${search}${hash}`
}
